import { AHButton, AHText, Box } from "arkh";
import { FormattedMessage } from "react-intl";
import { View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useLazyLoadQuery } from "react-relay";
import { Lottie } from "../../../components/Lottie";
import { StoreAdminNavigationScreenProps } from "../../StoreAdmin/StoreAdminNavigation";
import { AddScreenAssignDashboardPromptQuery } from "./__generated__/AddScreenAssignDashboardPromptQuery.graphql";

export const AddScreenAssignDashboardPrompt = (
  props: StoreAdminNavigationScreenProps<"AddScreenAssignDashboardPrompt">
) => {
  const safeAreaInsets = useSafeAreaInsets();

  const data = useLazyLoadQuery<AddScreenAssignDashboardPromptQuery>(
    graphql`
      query AddScreenAssignDashboardPromptQuery {
        store {
          dashboards {
            id
            name
          }
        }
      }
    `,
    {},
    { fetchPolicy: "store-and-network" }
  );

  const dashboardExists = data.store.dashboards.length > 0;

  return (
    <Box
      spaceHorizontal="large"
      spaceTop="large"
      spaceBottom="medium"
      style={{ height: "100%" }}
      insets={safeAreaInsets}
    >
      <AHText type="title-big" textAlign="center">
        <FormattedMessage
          description="StorecastAdminAddTVAssignDashboardPrompt title"
          defaultMessage="Almost there!"
        />
      </AHText>
      <AHText type="list-item-title" spaceVertical="large" textAlign="center">
        <FormattedMessage
          description="StorecastAdminAddTVAssignDashboardPrompt subtitle"
          defaultMessage="Dashboards can now be connected!"
        />
      </AHText>
      <Lottie
        source={require("./assign-dashboard.json")}
        autoPlay
        loop
        autoSize
        style={{ height: undefined, flex: 1 }}
      />
      <View style={{ flex: 1 }} />
      <AHButton
        title={
          <AHText type="title-small" color="lightText">
            {dashboardExists ? (
              <FormattedMessage
                description="StorecastAdminAddTVAssignDashboardPrompt assign dashboard button"
                defaultMessage="Connect a dashboard"
              />
            ) : (
              <FormattedMessage
                description="StorecastAdminAddTVAssignDashboardPrompt create dashboard button"
                defaultMessage="Create a dashboard"
              />
            )}
          </AHText>
        }
        themeType="primary"
        onPress={() => {
          if (dashboardExists) {
            props.navigation.replace("AddScreenAssignDashboard", {
              screenId: props.route.params.screenId,
              screenName: props.route.params.screenName,
            });
          } else {
            props.navigation.navigateDeprecated("StorecastCreate", {
              assignScreenId: props.route.params.screenId,
            });
          }
        }}
        iconRight
        iconType="dashboard"
      />
      <Box spaceTop="small" />
      <AHButton
        labelStyle={{ color: "#ff0000" }}
        title={
          <AHText type="title-small" color="text-cta">
            <FormattedMessage
              description="StorecastAdminAddTVAssignDashboardPrompt later button"
              defaultMessage="Do it later"
            />
          </AHText>
        }
        onPress={props.navigation.popToTop}
      />
    </Box>
  );
};
